import { useState } from "react";
import Header from "../../../../customs/Header";
import IndustrySetupContent from "./IndustrySetUp";
import { ReactComponent as World } from "../../../../svg/world.svg";
import CreateIndustryContent from "./CreateIndustrySetUpContent";
import SettingsModal from "../SettingsModal/settingsModal";

export const Main = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openRoleModal, setOpenRoleModal] = useState(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  const handleOpenRoleModal = () => setOpenRoleModal(true);

  return (
    <section>
      <Header
        props={{
          firstName: "All",
          secondName: "Industry Setup",
          buttonText: "Create Industry",
        }}
        handleOpen={handleOpenCreateModal}
      />

      <IndustrySetupContent handleClick={handleOpenRoleModal} />

      <SettingsModal
        header="Create Industry"
        open={openCreateModal}
        maxWidth={"712px"}
        content={<CreateIndustryContent handleClose={handleCloseCreateModal}  />}
        cancel={setOpenCreateModal}
        showrightIcon={false}
        worldIcon={<World/>}
      />

      
    </section>
  );
};

export default Main;

